module.exports = __webpack_public_path__ + "img/T4-C-rc_10.2b915ba1.png";